import * as React from "react"
const GamePublish = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.125}
        d="M16.5 8.782c-.647-2.925-1.607-4.79-3.145-5.244a3.216 3.216 0 0 0-.917-.13c-.945 0-1.69.563-3.374.563-1.684 0-2.432-.562-3.375-.562a3.484 3.484 0 0 0-.957.129c-1.54.454-2.49 2.321-3.145 5.244-.668 2.985-.547 5.344.759 5.796.914.317 1.731-.337 2.505-1.3.879-1.097 1.961-1.435 4.213-1.435 2.25 0 3.29.338 4.171 1.435.774.963 1.621 1.61 2.511 1.306 1.442-.493 1.422-2.782.753-5.802Z"
      />
      <path
        fill="#000"
        d="M10.33 8.612a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM11.876 10.159a.704.704 0 1 1 0-1.407.704.704 0 0 1 0 1.407ZM11.876 7.065a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM13.423 8.612a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.125}
        d="M5.689 6.221v3.375M7.376 7.91H4.001"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.064.034h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
)
export default GamePublish